let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("09MB9")).then(() => parcelRequire('b8OgH'));